import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import { TbDrone } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "react-bootstrap";
import PaginationS from "../../admin/Pagination";
import Static_modal from "../etc/Static_modal";
import { useLanguage } from "../../../Language/LanguageContext";
import Pilot_Status_User from "../../../Style_Component/Steps/User_Pilot_Status";
const StatusOperatingPilot = () => {
  const mapRef = useRef(null);
  let Navigate = useNavigate();
  const { t, changeLanguage, language, fontFamily } = useLanguage();
  const [itemsA, setItemsA] = useState([]);

  const [itemsB, setItemsB] = useState([
    {
      operation_id: 1,
      operation_code: "-",
      operation_start_time: "2023-03-03 12:00:00",
      operation_end_time: "2023-03-03 15:01:00",
      operation_status_text: "ไม่อนุมัติ",
      created_at: "2023-03-01 09:46:22",
      drone_list: "[1]",
      pilot_list: "[1]",
      area: "[100.92512471197985,13.12782983105395,100.91834887553279,13.132760540707881,100.91769756392657,13.12414501561266]",
      altitude: 65,
    },
  ]);

  const [allArea, setAllArea] = useState({});
  const [allArea2, setAllArea2] = useState({});
  const [showErroroperation, setShowErroroperation] = useState(false);
  const [selectedInformation, setSelectedInformation] = useState([]);
  const [showInfomation, setShowInfomation] = useState(false);
  const [showInfomation2, setShowInfomation2] = useState(false);
  const [accesspilot, setAccesspilot] = useState(false);
  const [showJoinConfirm, setShowJoinConfirm] = useState(false);
  const [showJoinReject, setShowJoinReject] = useState(false);
  const [userPilotData, setUserPilotData] = useState(undefined);
  const [namePilotData, setNamePilotData] = useState(undefined);
  const [selectedItem, setSelectedItem] = useState([]);
  const [checkpilot, setCheckpilot] = useState("");
  const [deletingSelect, setDeletingSelect] = useState([]);
  const [showDeletePilot, setShowDeletePilot] = useState(false);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();

  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleClose = () => {
    setShowInfomation(false);
    setShowInfomation2(false);
  };
  const handleShow = () => {
    setShowInfomation(true);
  };

  const CopyToClipboardButton = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`${text} copied to clipboard!`);
    } catch (error) {
      console.error("Error copying text to clipboard:", error);
    }
  };

  const getOperation = () => {
    let operationlist = AuthServiceV2.checkoperatorpilotlist();
    if (operationlist != null) {
      operationlist
        .then((response) => {
          if (response === "You are not a pilot") {
            setCheckpilot(true);
            setTimeout(() => {
              setCheckpilot(false);
              Navigate("/home");
            }, 2000);
          } else {
            if (response.data.pilot_data.length === 0) {
            } else {
              setNamePilotData(response.data.pilot_data[0].operator_name);
              console.log(response);
              const tempArray = [];
              const tempArray2 = [];
              const indata = response.data.pilot_data;
              ////console.log(indata);
              const outdata = response.data.pilot_data;
              const tempAreaObj = {};
              const tempAreaObj2 = {};
              ////console.log(indata[0]);
              for (
                let operationCount = 0;
                operationCount < response.data.pilot_data.length;
                operationCount++
              ) {
                tempArray.push(indata[operationCount]);

                // tempAreaObj[indata[operationCount].operation_id] =
                //   indata[operationCount].area;
                // tempAreaObj[
                //   response.data.pilot_data[operationCount].operation_id + "-Time"
                // ] = [
                //   response.data.pilot_data[operationCount].operation_start_time,
                //   response.data.pilot_data[operationCount].operation_end_time,
                // ];
              }
              for (
                let operationCount = 0;
                operationCount < response.data.pilot_data.length;
                operationCount++
              ) {
                tempArray2.push(outdata[operationCount]);

                // tempAreaObj2[outdata[operationCount].operation_id] =
                //   outdata[operationCount].area;
                // tempAreaObj2[
                //   response.data.pilot_data[operationCount].operation_id + "-Time"
                // ] = [
                //   response.data.pilot_data[operationCount].operation_start_time,
                //   response.data.pilot_data[operationCount].operation_end_time,
                // ];
              }
              ////console.log(tempArray);
              setItemsA(tempArray);
              setItemsB(tempArray);
              setAllArea(tempAreaObj);
              setAllArea2(tempAreaObj2);
            }
          }
          ////console.log(response);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };
  const responsetooperator = (status) => {
    const check = AuthServiceV2.responsepilot(
      selectedItem[0],
      selectedItem[1],
      status
    );
    if (check != null) {
      check
        .then((res) => {
          window.location.reload(false);
          //console.log(res);
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  };

  const getPilotData = () => {
    const pilotData = AuthServiceV2.checkpilot();
    if (pilotData != null) {
      pilotData
        .then((res) => {
          console.log(res.data);
          setUserPilotData(res.data);
        })
        .catch((err) => {
          setTextBody(err);
          setModalToggle({ ...modalToggle, modalErr: true });
          setTimeout(() => {
            Navigate("/home");
          }, 3000);
        });
    }
  };

  useEffect(() => {
    getOperation();
    getPilotData();
    addOneYearToDate();
  }, []);

  const [itemsPerPage] = useState(4);
  const [searchTermA, setSearchTermA] = useState("");
  const handleSearchA = (event) => {
    setSearchTermA(event.target.value);
  };
  const filteredDataA = itemsA.filter((item) => {
    return (
      item.operator_id
        .toString()
        .toLowerCase()
        .includes(searchTermA.toLowerCase()) ||
      item.operator_name
        .toString()
        .toLowerCase()
        .includes(searchTermA.toLowerCase())
    );
  });

  const [currentPageA, setCurrentPageA] = useState(0);
  const startIndexA = currentPageA * itemsPerPage;
  const endIndexA = startIndexA + itemsPerPage;
  const currentItemsA = filteredDataA.slice(startIndexA, endIndexA);
  const handleChagePageA = (page) => {
    if (page >= 0) setCurrentPageA(page);
  };
  const currentDate = formatDateToDmy(new Date());

  function formatDateToDmy(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1; // Month is zero-based, so we add 1
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const future = addOneYearToDate(new Date());
  function addOneYearToDate(date) {
    const newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + 1);
    const returndate = formatDateToDmy(newDate);
    return returndate;
  }

  const [searchValues, setSeachValue] = useState(["operator_name"]);
  const [portionData, setPortionData] = useState([]);
  const [startArr, setStartArr] = useState(0);
  const handlePortionChange = (newPortion, startarr) => {
    setPortionData(newPortion);
    setStartArr(startarr);
  };

  return (
    <div>
      <Modal
        show={showDeletePilot}
        onHide={() => {
          setDeletingSelect([]);
          setShowDeletePilot(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>ยืนยันการลบนักบิน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>คุณยืนยันที่จะถอนตัวหรือไม่</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="custom-btn btnCancel"
            onClick={() => {
              setDeletingSelect([]);
              setShowDeletePilot(false);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="custom-btn btnSave"
            onClick={() => {
              // deletePilot(deletingSelect[0], deletingSelect[1]);
              setDeletingSelect([]);
              setShowDeletePilot(false);
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="menu-selection">
        <h1>{t("managementpilot.main")}</h1>
      </div>
      <div className="table-container">
        <div className="menu-search-bar">
          <h1 className="header ">{t("managementpilot.submain1")}</h1>
        </div>

        <div style={{ height: "75px", width: "100%" }} />
        {userPilotData !== undefined ? (
          <div style={{ height: "400px" }}>
            <div
              style={{
                position: "relative",
                width: "750px",
                height: "100%",
                margin: "0px auto",
                padding: "20px",
                background:
                  "linear-gradient(101.27deg, #8A024B 0%, #C78300 100%)",
                borderRadius: "20px",
              }}
            >
              {/* <h3 style={{ color: "white" }}>ชื่อผู้ใช้ : {namePilotData}</h3> */}
              <h3 style={{ color: "white" }}>
                {t("managementpilot.type")} : {userPilotData.pilot_type}
              </h3>
              <br />
              <h3 style={{ color: "white" }}>
                {t("managementpilot.number")} : {userPilotData.pilot_id}
              </h3>

              <h4 style={{ color: "white" }}>
                {t("managementpilot.codeOpen")} :{" "}
                {userPilotData.pilot_data.code_open}
              </h4>
              <h4 style={{ color: "white" }}>
                {t("managementpilot.codeSpec")} :{" "}
                {userPilotData.pilot_data.code_specific}
              </h4>

              <br />
              {/* <h5 style={{ color: "white" }}>ISS : {userPilotData.pilotData.cert_status.start_date}</h5> */}
              {/* <h5 style={{ color: "white" }}>EXP : {userPilotData.pilotData.cert_status.end_date}</h5> */}
              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  bottom: "25px",
                  right: "50px",
                }}
              >
                {/* <TbDrone style={{ fontSize: "75px", color: "white" }} />
                <h1 style={{ margin: "auto 0px", color: "white" }}>AMETHYST</h1> */}
              </div>
              <div
                style={{
                  width: "190px",
                  height: "175px",
                  position: "absolute",
                  top: "15px",
                  right: "35px",
                }}
              >
                <h4 style={{ margin: "auto 0px", color: "white" }}>
                  UAV Pilot License
                </h4>
              </div>
              <h6
                style={{
                  position: "absolute",
                  top: "50px",
                  right: "65px",
                  color: "white",
                }}
              >
                Kingdom of Thailand
              </h6>
              <img
                src={
                  "https://images.emojiterra.com/openmoji/v13.1/512px/1f1f9-1f1ed.png"
                }
                alt="thailand"
                style={{
                  width: "100px",
                  height: "100px",
                  position: "absolute",
                  top: "60px",
                  right: "90px",
                }}
              />
            </div>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "25px",
              }}
            >
              <div
                onClick={() => {
                  CopyToClipboardButton(userPilotData.pilot_id);
                }}
                style={{
                  width: "250px",
                  height: "50px",
                  backgroundColor: "green",
                  borderRadius: "10px",
                  margin: "0px 25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <h5 style={{ color: "white" }}>คัดลอกหมายเลขนักบิน </h5>
              </div>
              <div
                onClick={() => {
                  CopyToClipboardButton(userPilotData.pilot_data.code_open);
                }}
                style={{
                  width: "250px",
                  height: "50px",
                  backgroundColor: "green",
                  borderRadius: "10px",
                  margin: "0px 25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <h5 style={{ color: "white" }}>คัดลอกรหัสนักบิน OPEN </h5>
              </div>
              <div
                onClick={() => {
                  CopyToClipboardButton(userPilotData.pilot_data.code_specific);
                }}
                style={{
                  width: "250px",
                  height: "50px",
                  backgroundColor: "green",
                  borderRadius: "10px",
                  margin: "0px 25px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <h5 style={{ color: "white" }}>คัดลอกรหัสนักบิน SPECIFIC</h5>
              </div>
            </div> */}
            <div style={{ display: "block" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  margin: "10px",
                }}
              >
                <div
                  style={{
                    border: "solid 1px",
                    width: "40%",
                    height: "80px",
                    fontSize: "22px",
                    display: "block",
                    borderRadius: "10px",
                    backgroundColor: " #0096c7",
                    color: "white",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <div style={{display: "flex",
                  justifyContent: "center",
                  alignContent: "center",}}>
                    สถานะการขอขึ้นทะเบียนนักบิน Spacific :{" "}
                    {userPilotData.pilot_data.cert_status?.status ? (
                      <Pilot_Status_User
                        status={userPilotData.pilot_data.cert_status.status}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div style={{display: "flex",
                  justifyContent: "center",
                  alignContent: "center",}}>comment: {userPilotData.pilot_data.cert_status?.comment ? (userPilotData.pilot_data.cert_status.comment):""}</div>
                </div>
                <div></div>
              </div>

              {userPilotData.pilot_data.cert_status?.status ? (
                userPilotData.pilot_data.cert_status.status === "อนุมัติ" ||
                userPilotData.pilot_data.cert_status.status === "ยื่นคำขอ" ? (
                  ""
                ) : (
                  <Button
                    className="custom-btn btnEdit2"
                    onClick={() => {
                      //deletePilot(deletingSelect[0], deletingSelect[1]);
                      Navigate("/user/pilot/regispilotspacific");
                    }}
                  >
                    แก้ไข
                  </Button>
                )
              ) : (
                ""
              )}
            </div>
          </div>
        ) : null}
      </div>
      {showInfomation === true && (
        <Modal
          show={showInfomation}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              ลำดับที่ {selectedInformation[0]} รหัสการปฏิบัติการ{" "}
              {selectedInformation[1]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div
              style={{
                width: "100%",
                height: "600px",
                backgroundColor: "black",
              }}
              ref={mapRef}
            ></div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                }}
              ></div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาเริ่มต้น : {selectedInformation[2]}</h4>
                </div>
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาสิ้นสุด : {selectedInformation[3]}</h4>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: "30%",
                    height: "100%",

                    textAlign: "center",
                  }}
                >
                  <h4>จำนวนโดรน : {selectedInformation[5]}</h4>
                </div>
                <div
                  style={{ width: "30%", height: "100%", textAlign: "center" }}
                >
                  <h4>
                    {/* จำนวนนักบิน : {JSON.parse(selectedInformation[6]).length} */}
                  </h4>
                </div>
                <div
                  style={{ width: "30%", height: "100%", textAlign: "center" }}
                >
                  <h4>ความสูง : {selectedInformation[7].toString()}</h4>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      {showInfomation2 === true && (
        <Modal
          show={showInfomation2}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              ลำดับที่ {selectedInformation[0]} รหัสการปฏิบัติการ{" "}
              {selectedInformation[1]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ margin: "0", padding: "0" }}>
            <div
              style={{
                width: "100%",
                height: "600px",
                backgroundColor: "black",
              }}
              ref={mapRef}
            ></div>
          </Modal.Body>
          <Modal.Footer>
            <div style={{ width: "100%", height: "100%" }}>
              <div
                style={{
                  display: "flex",
                }}
              ></div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาเริ่มต้น : {selectedInformation[2]}</h4>
                </div>
                <div
                  style={{ width: "50%", height: "100%", textAlign: "center" }}
                >
                  <h4>เวลาสิ้นสุด : {selectedInformation[3]}</h4>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: "30%",
                    height: "100%",

                    textAlign: "center",
                  }}
                >
                  <h4>จำนวนโดรน : {selectedInformation[5]}</h4>
                </div>
                <div
                  style={{ width: "30%", height: "100%", textAlign: "center" }}
                >
                  <h4>ความสูง : {selectedInformation[7].toString()}</h4>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      )}
      <Modal
        show={showErroroperation}
        onHide={() => setShowErroroperation(false)}
        aria-labelledby="contained-modal-title-vcenter"
        size="sm"
        centered
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            กรุณาขึ้นทะเบียนผู้ฎิบัติการก่อนค่ะ
          </div>
        </Modal.Body>
      </Modal>

      <div style={{ height: "100px" }} />

      <div className="container-main">
        <div className="table-card-header">
          <h4 className="header-main" style={{ color: "white" }}>
            {t("managementpilot.submain2")}
          </h4>
          {/* <div
            style={{
              background:
                "linear-gradient(294deg, rgba(13,170,1,1) 0%, rgba(65,129,0,1) 100%)",
              width: "150px",
              height: "50%",
              position: "absolute",
              right: "50px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "15px",
              cursor: "pointer",
              border: "1px solid rgba(65,129,0,1)",
            }}
            onClick={() => {}}
          >
            <h4 style={{ color: "white", margin: "0" }}>เพิ่มนักบิน</h4>
          </div> */}
        </div>
        <div style={{ textAlign: "end", marginTop: "35px" }}>
          <p>จำนวน {portionData.length}</p>
        </div>

        <Table
          striped
          bordered={false}
          hover
          className="table-main"
          style={{ marginTop: "0px" }}
        >
          <thead>
            <tr>
              <th className="table-space">{t("managementpilot.list")}</th>
              <th className="table-space">{t("managementpilot.name")}</th>
              <th className="table-space">{t("managementpilot.status")}</th>
              <th className="table-space">{t("managementpilot.Delete")}</th>
            </tr>
          </thead>
          <tbody>
            {portionData.length !== 0 ? (
              <>
                {portionData.map((item, index) => (
                  <tr key={startArr + index}>
                    <td className="table-space">{startArr + index + 1} </td>
                    <td className="table-space">{item.operator_name}</td>
                    <td className="table-space">
                      {item.status_text === "รอการตอบรับ" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            onClick={() => {
                              setSelectedItem([
                                item.operator_id,
                                item.co_id,
                                item.operator_name,
                              ]);
                              setShowJoinConfirm(true);
                            }}
                            className="custom-btn btnSave"
                            style={{ fontSize: "16px", margin: "0px 20px" }}
                          >
                            เข้าร่วม
                          </div>
                          <div
                            onClick={() => {
                              setSelectedItem([
                                item.operator_id,
                                item.co_id,
                                item.operator_name,
                              ]);
                              setShowJoinReject(true);
                            }}
                            className="custom-btn btnCancel"
                            style={{ fontSize: "16px" }}
                          >
                            ไม่เข้าร่วม
                          </div>
                        </div>
                      ) : (
                        <div style={{ color: "green", opacity: "0.8" }}>
                          {item.status_text}
                        </div>
                      )}
                    </td>
                    <td className="table-space">
                      <button
                        //disabled
                        onClick={() => {
                          //console.log("Test");
                          setDeletingSelect([
                            item.pilot_id,
                            item.co_id,
                            item.pilot_name,
                          ]);
                          setShowDeletePilot(true);
                        }}
                        className="custom-btn btnCancel"
                        style={{ fontSize: "16px" }}
                      >
                        X
                      </button>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <th colSpan={6}>
                <h4 className="header-main">ไม่พบข้อมูลผู้เข้าร่วม</h4>
              </th>
            )}
          </tbody>
        </Table>
        <PaginationS
          data={itemsA}
          onPortionChange={handlePortionChange}
          searchValue={searchValues}
        />
      </div>
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      <Modal
        size="lg"
        show={showJoinConfirm}
        onHide={() => {
          setShowJoinConfirm(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>ยืนยันการเข้าร่วม</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h4 style={{ textAlign: "center" }}>
              คุณยืนยันที่จะเข้าร่วมเป็นนักบินให้กับผู้ปฏิบัติการ
            </h4>
            <h2 style={{ textAlign: "center" }}>{selectedItem[2]}</h2>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="custom-btn btnCancel"
            onClick={() => {
              setSelectedItem([]);
              setShowJoinConfirm(false);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="custom-btn btnSave"
            onClick={() => {
              responsetooperator(2);
              setSelectedItem([]);
              setShowJoinConfirm(false);
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        show={showJoinReject}
        onHide={() => {
          setShowJoinReject(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>ปฏิเสธนการเข้าร่วม</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h4 style={{ textAlign: "center" }}>
              คุณยืนยันที่จะปฏิเสธการเป็นนักบินให้กับผู้ปฏิบัติการ
            </h4>
            <h2 style={{ textAlign: "center" }}>{selectedItem[2]}</h2>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="custom-btn btnCancel"
            onClick={() => {
              setShowJoinReject(false);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="custom-btn btnSave"
            onClick={() => {
              responsetooperator(3);
              setShowJoinReject(false);
            }}
          >
            ยืนยัน
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={checkpilot}
        onHide={() => {
          setCheckpilot(false);
        }}
        className="font-cen"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>แจ้งเตือน</Modal.Title>
        </Modal.Header>
        <Modal.Body>ท่านยังไม่ได้เป็นนักบิน</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setCheckpilot(false);
            }}
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StatusOperatingPilot;
